import BaseController from '@humandigital-agency/base-controller';

class ScrollTabs {
    /**
     * @param {HTMLElement} container
     */
    constructor(container) {
        this.container = container;
        this.targets = [];
        this.activeElement;
        this.offset = 250;
    }

    init() {
        Array.from(this.container.querySelectorAll(`.tabHeaders li a`)).forEach((header) => {
            let target = document.querySelector(header.dataset.scrollTo);
            if (target) {
                this.targets.push({
                    header: header,
                    element: target,
                    top: window.app.elementCoords(target).top,
                });
            }
        });
        this.targets.reverse(); // Fffffflip

        // Scroll event: check best match
        window.app.registerScrollEvent(this.scroll.bind(this));

        // Resize event: Recalc all positions
        window.app.registerResizeEvent(this.getTargetPositions.bind(this));
    }

    scroll() {
        const scrollY = window.scrollY;

        for (let i = 0; i < this.targets.length; i ++) {
            if (scrollY + this.offset < this.targets[i].top) {
                continue;
            } else {
                this.activeTarget = this.targets[i];
                this.updateActiveStatus();
                break;
            }
        }
    }

    updateActiveStatus() {
        this.targets.forEach(target => {
            target.header.classList.toggle('isActive', this.activeTarget == target);
        })
    }

    getTargetPositions() {
        this.targets.forEach((target) => {
            target.top = window.app.elementCoords(target.element).top;
        });
    }
}

export default class ScrollTabsController extends BaseController {
    constructor() {
        super('[data-scroll-tabs]', ScrollTabs);
    }
}
